/*
if (!document.documentElement.dataset.dev) {
    var customeElementsAdapterScript = document.createElement('script');
    // customeElementsAdapterScript.async = true;
    customeElementsAdapterScript.src = 'https://s3.amazonaws.com/motor1-v2.com-cdn/custom/polymer2/webcomponentsjs/custom-elements-es5-adapter.js';
    // customeElementsAdapterScript.src = '/polymer2/bower_components/webcomponentsjs/custom-elements-es5-adapter.js';
    document.head.appendChild(customeElementsAdapterScript);
}
*/

// Polyfill for IE11
if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
        'use strict';
        if (typeof start !== 'number') {
            start = 0;
        }
        
        if (start + search.length > this.length) {
            return false;
        } else {
            return this.indexOf(search, start) !== -1;
        }
    };
}

// Load webcomponentsjs polyfill if browser does not support native Web Components
window.addEventListener('DOMContentLoaded', function() {
    'use strict';

    var webComponentsSupported = (
        'registerElement' in document
        && 'import' in document.createElement('link')
        && 'content' in document.createElement('template')
    );

    var webAnimationsScript = document.createElement('script');
    webAnimationsScript.async = true;
    // webAnimationsScript.src = '/polymer2/bower_components/web-animations-js/web-animations-next-lite.min.js';
    webAnimationsScript.src = '/design/src/js/polymer2/web-animations-js/web-animations-next-lite.min.js';
    // webAnimationsScript.src = 'https://cdn.motor1.com/custom/polymer2/web-animations-js/web-animations-next-lite.min.js';
    document.head.appendChild(webAnimationsScript);

    if (!webComponentsSupported) {
        var script = document.createElement('script');
        script.async = true;
        // script.src = '/polymer2/bower_components/webcomponentsjs/webcomponents-lite.js';
        script.src = '/design/src/js/polymer2/webcomponentsjs/webcomponents-loader.js';
        // script.src = 'https://cdn.motor1.com/custom/polymer2/webcomponentsjs/webcomponents-loader.js';
        document.head.appendChild(script);
    }
});